module.exports = __webpack_public_path__ + "img/Factureren.0c22ba0d.png";